import React from 'react';
import { MaxDataSection } from './styles';

function MaxDataInfo({ title, data, unit }) {
  const [timestamp, val1, val2] = data;
  return (
    <MaxDataSection className="col-xs-12">
      <div className="jumbotron">
        <h3>{`รายละเอียดค่าสูงสุดในกราฟ ${title}`}</h3>
        <p>{`พบค่าสูงสุดที่เวลา ${timestamp} โดยมีค่า [ ${val1}, ${val2} ] ${unit}`}</p>
      </div>
    </MaxDataSection>
  );
}

export default MaxDataInfo;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeismicWave/MaxDataInfo.js